import React from "react";
import Linkify from "react-linkify";
import { Link } from "@sonder/ui/source/styled/fragments/Link";

interface ParsedTextProps {
  children?: React.ReactNode;
}

export const ParsedText = ({ children }: ParsedTextProps) => (
  <Linkify
    componentDecorator={(href, text, key) => (
      <Link href={href} key={key} rel="noopener noreferrer" target="_blank">
        {text}
      </Link>
    )}
  >
    {children}
  </Linkify>
);
